import React from "react";
import "./CompanyIntro.css";

const stats = [
  { value: "71+", label: "Years of Excellence" },
  { value: "5+", label: "Battery Categories" },
  { value: "500K+", label: "Happy Customers" },
];

function CompanyIntro() {
  return (
    <section className="company-intro">
      <div className="company-container">

        <div className="company-image-wrapper">
          <div className="image-accent" />
          <img
            src="/comabout.jpg"
            alt="Oster Battery Products"
            className="company-image"
          />
        </div>

        <div className="company-description">
          <span className="company-eyebrow">Who We Are</span>
          <h2 className="company-title">
            Power Built<br />to Last
          </h2>
          <div className="company-divider" />
          <p className="company-text">
            At Oster, we engineer batteries that power homes, vehicles, and
            industries. Backed by selenium technology and rigorous quality
            standards, every Oster battery delivers enduring performance you
            can depend on — day after day, year after year.
          </p>
          <div className="company-stats">
            {stats.map((stat, i) => (
              <div key={i} className="stat-item">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default CompanyIntro;
